<template>
  <div>
    <div class="main-content card p-1" v-if="loader === 100">
      <div class="row">
        <div class="col-md-12">
          <label>Nome</label>
          <input type="text" class="form-control" v-model="setor.nome" />
        </div>
        <div class="col-md-6 mt-1">
          <label>Capacidade do Setor</label>
          <input
            type="number"
            class="form-control"
            v-model="setor.capacidade_setor"
          />
        </div>
        <div class="col-md-6 mt-1">
          <label>Quantidade Máxima para Alerta</label>
          <input
            type="number"
            class="form-control"
            v-model="setor.quantidade_maxima_alerta"
          />
        </div>
        <div class="col-md-3">
          <br />
          <label
            class="btn btn-primary w-100"
            v-bind:class="{ disabled: !setor.mostra_classificacao }"
            style="cursor: pointer"
          >
            <input
              type="checkbox"
              v-model="setor.mostra_classificacao"
              class="d-none"
            />
            Exibir Coluna Classificação de Risco
          </label>
        </div>
        <div class="col-md-3">
          <br />
          <label
            class="btn btn-primary w-100"
            v-bind:class="{ disabled: !setor.classifica }"
            style="cursor: pointer"
          >
            <input type="checkbox" v-model="setor.classifica" class="d-none" />
            Classifica Risco
          </label>
        </div>
        <div class="col-md-3">
          <br />
          <label
            class="btn btn-primary w-100"
            v-bind:class="{ disabled: !setor.finaliza }"
            style="cursor: pointer"
          >
            <input type="checkbox" v-model="setor.finaliza" class="d-none" />
            Finaliza Senha
          </label>
        </div>
        <div class="col-md-3">
          <br />
          <label
            class="btn btn-primary w-100"
            v-bind:class="{ disabled: !setor.medicacao }"
            style="cursor: pointer"
          >
            <input type="checkbox" v-model="setor.medicacao" class="d-none" />
            Envia para Medicação
          </label>
        </div>
        <div class="col-md-3">
          <br />
          <label
            class="btn btn-primary w-100"
            v-bind:class="{ disabled: !setor.espera }"
            style="cursor: pointer"
          >
            <input type="checkbox" v-model="setor.espera" class="d-none" />
            Envia para Espera
          </label>
        </div>
        <div class="col-md-3">
          <br />
          <label
            class="btn btn-primary w-100"
            v-bind:class="{ disabled: !setor.prioridade }"
            style="cursor: pointer"
          >
            <input type="checkbox" v-model="setor.prioridade" class="d-none" />
            Muda Prioridade
          </label>
        </div>
        <div class="col-md-3">
          <br />
          <label
            class="btn btn-primary w-100"
            v-bind:class="{ disabled: !setor.agenda_consulta }"
            style="cursor: pointer"
          >
            <input
              type="checkbox"
              v-model="setor.agenda_consulta"
              class="d-none"
            />
            Agenda Consulta
          </label>
        </div>
        <div class="col-md-3">
          <br />
          <label
            class="btn btn-primary w-100"
            v-bind:class="{ disabled: !setor.envia_ares_triagem }"
            style="cursor: pointer"
          >
            <input
              type="checkbox"
              v-model="setor.envia_ares_triagem"
              class="d-none"
            />
            Envia para Ares Triagem
          </label>
        </div>
        <div class="col-md-12 mt-2">
          <h4>Fluxo</h4>
        </div>
        <div class="col-md-3">
          <button class="btn btn-primary w-100" @click="desmarcar()">
            Desmarcar todos
          </button>
        </div>
        <div class="col-md-3">
          <button class="btn btn-primary w-100" @click="marcar()">
            Marcar Todos
          </button>
        </div>
        <div class="col-md-3">
          <button class="btn btn-primary w-100" @click="inverter()">
            Inverter seleção
          </button>
        </div>
        <div class="col-md-12 mb-2"></div>
        <div class="col-md-3" v-for="fluxo in allSetores" :key="fluxo.id">
          <label
            class="btn btn-primary w-100"
            v-bind:class="{ disabled: !fluxo.ativo }"
            style="cursor: pointer"
          >
            <input type="checkbox" v-model="fluxo.ativo" class="d-none" />
            {{ fluxo.nome }}
          </label>
        </div>

        <!-- Seção e-SUS: Tipos de Serviço -->
        <div class="col-md-12 mt-3" v-if="esusAtivo">
          <h4>Tipos de Serviço e-SUS</h4>
          <p class="text-muted" style="font-size: 12px">
            Selecione os tipos de serviço do e-SUS que devem tocar a senha neste
            setor.
          </p>
          <v-select
            v-model="esusTiposSelecionados"
            :options="esusTiposDisponiveis"
            label="no_tipo_servico"
            :reduce="(tipo) => tipo"
            multiple
            placeholder="Selecione os tipos de serviço..."
          />
        </div>

        <div class="col-md-12 text-right">
          <hr />
          <router-link to="/setores" class="btn btn-back mr-1">
            <i class="fa fa-arrow-left"></i> Voltar
          </router-link>
          <a class="btn btn-add" @click="save">
            Salvar
            <i class="fa fa-save"></i>
          </a>
        </div>
      </div>
    </div>
    <div class="row justify-content-center mt-3" v-else>
      <div class="col-10 text-center">
        <div class="progress">
          <div
            class="progress-bar bg-primary"
            role="progressbar"
            :style="'width: ' + loader + '%;'"
            aria-valuemin="0"
            aria-valuemax="100"
          ></div>
        </div>
        <b style="font-size: 14pt">Carregando</b><br />
        <b style="font-size: 16pt; line-height: 12pt">{{ loader }}%</b>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";

export default {
  name: "imageUpload",
  data() {
    return {
      loader: 0,
      setor: {},
      allSetores: [],
      esusTiposDisponiveis: [],
      esusTiposSelecionados: [],
      esusAtivo: false,
    };
  },
  computed: {},
  methods: {
    makeFormData: function () {
      const self = this;
      let fd = new FormData();

      fd.append("nome", self.setor.nome ? self.setor.nome : "");
      fd.append(
        "capacidade_setor",
        self.setor.capacidade_setor ? self.setor.capacidade_setor : ""
      );
      fd.append(
        "quantidade_maxima_alerta",
        self.setor.quantidade_maxima_alerta
          ? self.setor.quantidade_maxima_alerta
          : ""
      );
      fd.append("classifica", self.setor.classifica ? 1 : 0);
      fd.append("finaliza", self.setor.finaliza ? 1 : 0);
      fd.append("medicacao", self.setor.medicacao ? 1 : 0);
      fd.append("espera", self.setor.espera ? 1 : 0);
      fd.append("prioridade", self.setor.prioridade ? 1 : 0);
      fd.append("agenda_consulta", self.setor.agenda_consulta ? 1 : 0);
      fd.append("envia_ares_triagem", self.setor.envia_ares_triagem ? 1 : 0);
      fd.append(
        "mostra_classificacao",
        self.setor.mostra_classificacao ? 1 : 0
      );
      fd.append("ativo", 1);
      fd.append("setores", JSON.stringify(self.allSetores));
      fd.append(
        "esus_tipos_servico",
        JSON.stringify(
          self.esusTiposSelecionados.map((t) => ({
            tp_servico: t.co_seq_tipo_servico,
            no_tipo_servico: t.no_tipo_servico,
          }))
        )
      );

      fd.append("_method", "POST");

      if (self.setor.id) {
        fd.append("id", self.setor.id);
        fd.append("_method", "PUT");
      }

      return fd;
    },
    save: function () {
      const self = this;
      let api = self.$store.state.api + "setores";

      self.$loading(true);

      let fd = self.makeFormData();

      if (self.setor.id) {
        api += "/" + self.setor.id;
      }

      axios
        .post(api, fd)
        .then(() => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );

          self.$loading(false);
          this.$router.push("/setores");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
          self.$loading(false);
        });
    },
    getEsusTipos: function () {
      const self = this;
      axios
        .get(self.$store.state.api + "esus/tipos-servico")
        .then((response) => {
          self.esusTiposDisponiveis = response.data;
          self.esusAtivo = true;
        })
        .catch(() => {
          // e-SUS não configurado nessa instalação, oculta a seção
          self.esusAtivo = false;
        });
    },
    getEsusTiposVinculados: function (setor_id) {
      const self = this;
      axios
        .get(
          self.$store.state.api +
            `esus_tipo_servico_setores?paginated=false&setor_id=${setor_id}`
        )
        .then((response) => {
          const vinculados = response.data.data || response.data;
          // Mapeia para o formato do v-select (igual ao esusTiposDisponiveis)
          self.esusTiposSelecionados = vinculados.map((v) => ({
            co_seq_tipo_servico: v.tp_servico,
            no_tipo_servico: v.no_tipo_servico,
          }));
        })
        .catch(() => {});
    },
    getSetores: function (id) {
      const self = this;
      const api = self.$store.state.api + "setores/" + id + "?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.setor = response.data.data[0];
          self.setLoader(25);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getAllSetores: function () {
      const self = this;
      var api = self.$store.state.api + "setores?ativo=1&paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.allSetores = response.data.data;

          self.setLoader(25);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getFluxos: function (id) {
      const self = this;
      var api =
        self.$store.state.api +
        `fluxo_setores?with[]=setor&paginated=false&setor_original_id=${id}`;

      axios.get(api).then((response) => {
        if (response.data && response.data.data) {
          response.data.data.forEach((setor) => {
            setor.nome = setor.setor ? setor.setor.nome : "";
          });

          // Filtrar apenas setores ativos no frontend
          self.allSetores = response.data.data.filter(
            (fluxo) => fluxo.setor && fluxo.setor.ativo == 1
          );
          self.setLoader(25);
        } else {
          console.error("Unexpected response format:", response);
          self.$message(null, "Unexpected response format", "error");
        }
      });
    },
    marcar: function () {
      const self = this;

      self.allSetores.forEach((fluxo) => {
        fluxo.ativo = true;
      });
    },
    desmarcar: function () {
      const self = this;

      self.allSetores.forEach((fluxo) => {
        fluxo.ativo = false;
      });
    },
    inverter: function () {
      const self = this;

      self.allSetores.forEach((fluxo) => {
        fluxo.ativo = !fluxo.ativo;
      });
    },
    setLoader: function (qtd) {
      const self = this;

      let load = 0;
      let interval = setInterval(function () {
        self.loader++;
        load++;

        if (load == qtd) {
          clearInterval(interval);
        }
      }, 15);
    },
  },
  mounted: function () {
    const self = this;
    let id = self.$route.params.id;

    self.setLoader(50);
    self.getEsusTipos();

    if (id) {
      self.getSetores(id);
      self.getFluxos(id);
      self.getEsusTiposVinculados(id);
    } else {
      self.getAllSetores();
      self.setLoader(25);
    }
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}
.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}
.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important ;
}
.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>